/* eslint import/prefer-default-export:0 */

const pluralizeWord = (word, patternSuffix = 'y', replaceSuffix = 'ies') => {
    if (patternSuffix === null && replaceSuffix) {
        return `${word}${replaceSuffix}`;
    }
    const regex = new RegExp(`${patternSuffix}$`, 'i');
    const pluralized = word.replace(regex, replaceSuffix);
    return pluralized;
};

const pluralText = (number, word, hideIfZero = false) => {
    if (number == null) {
        return '';
    }

    if (hideIfZero && number === 0) {
        return '';
    }

    if (number === 1) {
        return `${number} ${word}`;
    }

    let patternSuffix = null;
    let replaceSuffix = 's';

    if (word.slice(-2) === 'af') {
        patternSuffix = 'f';
        replaceSuffix = 'ves';
    } else if (word.slice(-2) === 'ry' || word.slice(-2) === 'ly') {
        patternSuffix = 'y';
        replaceSuffix = 'ies';
    }

    return `${number} ${pluralizeWord(word, patternSuffix, replaceSuffix)}`;
};

export { pluralText, pluralizeWord };
